<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="550"
    >
      <v-card class="body-1">
        <v-toolbar :color="lessonColor" flat>
          <v-toolbar-title>Занятие</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md>
          <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
            <v-col lg="12" md="12" xl="12" sm="12">
              <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
                <v-col :lg=lessonInfoWidth :xl=lessonInfoWidth :md=lessonInfoWidth sm="12">
                  <h2 class="body-1 font-weight-medium">
                    {{ lesson.beginTime }}-{{ lesson.endTime }}, {{ lessonDate }}</h2>
                  <h2 class="body-1">{{ className }}</h2>
                  <h2 class="body-1">{{ filialName }}</h2>
                  <h2 class="body-1 mb-3">{{ filialAddress }}</h2>
                  <div class="caption mt-2 mb-3 grey--text text--darken-2" v-if="record && record.missedRecord">
                    <div>Отработка за пропуск:</div>
                    <div>
                      <div>{{ missedLesson.classTitle }}</div>
                      <div>{{ missedLesson.date }} {{ record.missedRecord.beginTime }} - {{ record.missedRecord.endTime }}</div>
                      <div>{{ missedLesson.filialName }}</div>
                    </div>
                  </div>
                  <div class="caption mt-2 mb-3 grey--text text--darken-2" v-if="record && record.workOffRecord">
                    <div v-if="!record.workOffRecord.lessonStatus || record.workOffRecord.visit">Отработка:</div>
                    <div v-if="record.workOffRecord.lessonStatus && !record.workOffRecord.visit">Пропущена отработка:</div>
                    <div>
                      <div>{{ workOffLesson.classTitle }}</div>
                      <div>{{ workOffLesson.date }} {{ record.workOffRecord.beginTime }} - {{ record.workOffRecord.endTime }}</div>
                      <div>{{ workOffLesson.filialName }}</div>
                    </div>
                  </div>

                  <p v-if="!record && canRecord && lesson.freeRecords!==null">
                    Ост. {{ lesson.freeRecords }} мест
                  </p>
                  <p v-if="!record && canRecord && lesson.freeRecords===null && classFreeRecords">
                    Ост. {{ classFreeRecords }} мест
                  </p>
                </v-col>
                <v-col v-if="lesson.status===1 && record" md="4" lg="4" xl="4" xs="12" sm="12">
                  <div class="grey lighten-3 pa-1 text-center">
                    <div
                      v-if="lesson.status && record && record.visit"
                      class="font-weight-bold" :class="{ 'green--text': !missedLesson, 'purple--text' : !!missedLesson}">
                      Посетил
                      <span
                        v-if="classPayType === 'lessons'
                        && record
                        && !record.bill
                        && !record.free"
                        class="red--text">-1</span>
                    </div>
                    <div
                      v-if="lesson.status && record && !record.visit"
                      class="red--text font-weight-bold">
                      Пропуск
                    </div>
                    <span
                      v-if="classPayType === 'lessons'
                        && lesson.status===1
                        && record
                        && !record.free
                        && !record.goodReason
                        && (record.bill && !record.bill.userSubscriptionId)"
                      class="red--text">В долг
                    </span>
                    <div v-if="mark('lesson') || mark('home')" style="margin-bottom: 5px">
                      <div v-if="mark('lesson')">Оценка {{ mark('lesson') }}</div>
                      <div v-if="mark('home')">Оценка ДЗ{{ mark('home') }}</div>
                    </div>
                    <div class="grey--text text--darken-2 body-2"
                         v-if="record && record.test">Пробное
                    </div>
                    <div class="grey--text text--darken-2 body-2"
                         v-if="record && record.goodReason">Болеет/отпуск
                    </div>
                    <div
                      v-if="record && record.free" class="green--text">Бесплатно
                    </div>
                    <div
                      v-if="classPayType === 'lessons'
                      && record
                      && record.bill
                      && record.bill.userSubscriptionId
                      && (!record.workOffRecord || (
                        record.workOffRecord
                        && (record.bill.summa || record.bill.lessonsCount)
                      ))"
                      class="grey--text text--darken-2 body-2">
                      <span v-if="UISettings.showSubsDebits">
                        <money :sum="-record.bill.summa"></money>
                      </span>
                      <div>
                        Аб.
                        {{ userSubscriptionId }}
                      </div>
                    </div>
                    <div
                      v-if="classPayType === 'lessons'
                      && record
                      && record.bill
                      && record.bill.userSubscriptionId
                      && record.workOffRecord
                      && !record.bill.summa
                      && !record.bill.lessonsCoun"
                      class="grey--text text--darken-2 body-2">
                      <div>
                        Отработка
                      </div>
                    </div>

                  </div>
                </v-col>
                <v-col
                  v-if="lesson.status===0 && lessonInfoWidth !== 12"
                  :md=recordButtonWidth
                  :lg=recordButtonWidth
                  xl=recordButtonWidth xs="12" sm="12"
                  class="align-center text-center text-sm-right"
                >
                  <v-btn small rounded depressed
                         color="primary"
                         @click="createRecord"
                         v-if="canRecord && !isRecordFrozen && !record && !lesson.status">
                    Записаться
                  </v-btn>
                  <v-btn small rounded depressed
                         color="error"
                         @click="cancelRecord"
                         v-if="canCancelRecord && record && !lesson.status">
                    Отменить зап
                  </v-btn>
                  <v-btn small rounded
                         color="disabled"
                         :class="{ 'no-click': true }"
                         v-if="isRecordFrozen && !record">
                    Абонемент заморожен
                  </v-btn>
                  <div v-if="mark('lesson') || mark('home')" class="grey lighten-3 pa-1 text-center"
                       v-bind:style="{marginTop: !showRecordButton ? '0' : '15px'}"
                  >
                    <div v-if="mark('lesson')">Оценка {{ mark('lesson') }}</div>
                    <div v-if="mark('home')">Оценка ДЗ{{ mark('home') }}</div>
                  </div>
                </v-col>
              </v-row>

              <p v-if="lesson.topic">
                <span class="font-weight-bold">Тема: </span>
                <span v-html="getTextWithLinks(lesson.topic)"></span>
              </p>

              <p>
                <span class="font-weight-bold">Зал/кабинет:</span> {{ roomName }}<br>
                {{ teachers }}
              </p>
              <p v-if="lesson.description">
                <span class="font-weight-bold">Описание занятия: </span>
                <span v-html="getTextWithLinks(lesson.description)"></span>
              </p>

              <p v-if="comment">
                <span class="font-weight-bold">Комментарий:</span> {{ comment }}
              </p>

              <div v-if="!answer('lesson') && !hasLessonTask && allowAnswerIfNoTask" class="mb-5">
                <v-btn  @click="openNewAnswerPanel('lesson')"
                        color="primary"
                        small
                        rounded
                        depressed>
                  + ответ на урок
                </v-btn>
              </div>

              <div class="mb-5" v-if="!answer('home') && !hasLessonTask && allowAnswerIfNoTask">
                <v-btn  @click="openNewAnswerPanel('home')"
                        color="primary"
                        small
                        rounded
                        depressed>
                  + ответ на д/з
                </v-btn>
              </div>


              <v-card v-if="hasWebinar" outlined class="mb-5">
                <v-card-title class="text-h7 justify-space-between" flex>
                  <span>Вебинар</span>
                  <v-btn v-if="!webinarRestricted"
                         :href=webinar.value
                         small rounded depressed
                         color="primary"
                         target="_blank">Открыть
                  </v-btn>
                  <v-btn small rounded depressed
                         v-if="webinarRestricted && webinarRestricted !== 'earlyAccess'"
                         color="primary"
                         @click="showRestrictAccessModal=true"
                         class="white--text"
                  >Получить доступ
                  </v-btn>
                </v-card-title>
                <v-card-text v-if="webinarRestricted === 'earlyAccess'" class="text-body-2">
                  Информация будет доступна {{ webinarAccessAt }}
                </v-card-text>
                <v-card-text v-if="webinar && webinar.description">
                  <span v-html="getTextWithLinks(webinar.description)"></span>
                </v-card-text>
              </v-card>


              <v-card v-if="hasVideo" outlined class="mb-5">
                <v-card-title class="text-h7 justify-space-between" flex>
                  <span>Видео</span>
                  <v-btn
                    small rounded depressed
                    v-if="videoRestricted && videoRestricted !== 'earlyAccess'"
                    color="primary"
                    @click="showRestrictAccessModal=true"
                    class="white--text"
                  >
                    Получить доступ
                  </v-btn>
                  <v-btn
                    v-if="!videoRestricted"
                    @click="openLink()"
                    small rounded depressed
                    color="primary"
                  >
                    Открыть
                  </v-btn>

                </v-card-title>
                <v-card-text class="text-body-2" v-if="videoRestricted === 'earlyAccess'">
                  Информация будет доступна {{ videoAccessAt }}
                </v-card-text>
                <v-card-text v-if="video && (video.description || videoLink)" class="video-box">
                  <div v-if="video.description" v-html="getTextWithLinks(video.description)"></div>
                  <iframe
                    v-if="videoLink"
                    :src=videoLink
                    height="300"
                    style="width: 100%"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                  </iframe>
                </v-card-text>
              </v-card>


              <v-card v-if="hasLessonTask || (answer('lesson') && allowAnswerIfNoTask)"
                      outlined class="mb-5">
                <v-card-title class="text-h7 justify-space-between" flex>
                  <span>Задание на занятие</span>
                  <v-btn small rounded depressed
                         v-if="hasLessonTask && lessonTaskRestricted
                         && lessonTaskRestricted !== 'earlyAccess'"
                         color="primary"
                         @click="showRestrictAccessModal=true"
                         class="white--text"
                  >Получить доступ
                  </v-btn>
                </v-card-title>
                <v-card-text v-if="lessonTaskRestricted === 'earlyAccess'
                && hasLessonTask" class="text-body-2">
                  Информация будет доступна {{ lessonTaskAccessAt }}
                </v-card-text>
                <v-card-text v-if="!hasLessonTask">
                  Задание пока не задано
                </v-card-text>
                <v-card-text v-if="!lessonTaskRestricted && loadedLesson.lessonTask">
                  <span v-if="!lessonTaskRestricted
                  && loadedLesson.lessonTask"
                        class="task-wrapper" v-html="getTaskText(loadedLesson.lessonTask.text)">
                  </span>

                  <p v-if="!lessonTaskRestricted
                && loadedLesson.lessonTask
                && loadedLesson.lessonTask.files
                && loadedLesson.lessonTask.files.length">
                    <span class="font-weight-bold">Файлы: </span>
                    <span :key="file.id" v-for="(file, index) of loadedLesson.lessonTask.files">
                  <a v-if="!file.downloadUrl && !file.uploadState" @click="downloadFile(file)"
                     style="word-break: break-all"
                     class="green-text preset">
                      {{ file.original }}<span
                    v-if="index !== loadedLesson.lessonTask.files.length - 1"><br/>
                      </span>
                  </a>
                  <a v-if="file.downloadUrl && !showFileText(file)"
                     :href="file.downloadUrl"
                     target="_blank"
                     rel="noreferrer"
                     style="word-break: break-all"
                     class="green-text preset">
                      {{ file.original }}<span
                    v-if="index !== loadedLesson.lessonTask.files.length - 1"><br/>
                      </span>
                  </a>
                  <span v-if="!file.downloadUrl && showFileText(file)"
                        :href="file.downloadUrl"
                        target="_blank"
                        rel="noreferrer"
                        style="word-break: break-all"
                        class="green-text preset">
                      {{ file.original }}
                      <span class="help-text"
                            v-if="showFileText(file)">
                              {{ fileStateText(file) }}
                      </span>
                      <span v-if="index !== loadedLesson.lessonTask.files.length - 1"><br/>
                      </span>
                  </span>
                </span>
                  </p>
                </v-card-text>
                <v-card-text v-if="answer('lesson') && !lessonTaskRestricted"
                             class="grey lighten-3 answer-row">
                <span class="answer-name" @click="openAnswerPanel('lesson')">
                  <span>Мой ответ на урок</span>
                  <span class="status">{{ answerStatus('lesson') }}</span>
                </span>
                  <span v-if="mark('lesson')">Оценка{{ mark('lesson') }}</span>
                  <v-btn text color="primary" @click="openAnswerPanel('lesson')">Открыть</v-btn>
                </v-card-text>

                <v-card-actions flex class="justify-end mr-2" v-if="!lessonTaskRestricted">
                  <v-btn
                    v-if="!answer('lesson') && allowAnswer"
                    small
                    color="primary"
                    :rounded="true"
                    @click="openNewAnswerPanel('lesson')"
                    class="white--text">
                    + ответ на урок
                  </v-btn>
                </v-card-actions>
              </v-card>


              <v-card
                v-if="hasHomeTask || (answer('home') && allowAnswerIfNoTask)"
                outlined
                class="mb-5"
              >
                <v-card-title class="text-h7 justify-space-between" flex>
                  <span>Домашнее задание</span>
                  <v-btn
                    small rounded depressed
                    v-if="hasHomeTask && homeTaskRestricted && homeTaskRestricted !== 'earlyAccess'"
                    color="primary"
                    @click="showRestrictAccessModal=true"
                    class="white--text"
                  >
                    Получить доступ
                  </v-btn>
                </v-card-title>
                <v-card-text
                  v-if="hasHomeTask && homeTaskRestricted === 'earlyAccess'"
                  class="text-body-2"
                >
                  Информация будет доступна {{ homeTaskAccessAt }}
                </v-card-text>
                <v-card-text v-if="!hasHomeTask">
                  Задание пока не задано
                </v-card-text>
                <v-card-text v-if="!homeTaskRestricted && loadedLesson.homeTask">
                  <span
                    v-if="!homeTaskRestricted && loadedLesson.homeTask"
                    class="task-wrapper"
                    v-html="getTaskText(loadedLesson.homeTask.text)"
                  ></span>

                  <p
                    v-if="!homeTaskRestricted
                      && loadedLesson.homeTask
                      && loadedLesson.homeTask.files
                      && loadedLesson.homeTask.files.length"
                  >
                    <span class="font-weight-bold">Файлы: </span>
                    <span :key="file.id" v-for="(file, index) of loadedLesson.homeTask.files">
                      <a
                        v-if="!file.downloadUrl && !file.uploadState"
                        @click="downloadFile(file)"
                        style="word-break: break-all"
                        class="green-text preset"
                      >
                        {{ file.original }}
                        <span v-if="index !== loadedLesson.homeTask.files.length - 1"><br/></span>
                      </a>
                      <a
                        v-if="file.downloadUrl && !showFileText(file)"
                        :href="file.downloadUrl"
                        rel="noreferrer"
                        target="_blank"
                        style="word-break: break-all"
                        class="green-text preset"
                      >
                        {{ file.original }}
                        <span v-if="index !== loadedLesson.homeTask.files.length - 1"><br/></span>
                      </a>
                      <span
                        v-if="!file.downloadUrl && showFileText(file)"
                        :href="file.downloadUrl"
                        rel="noreferrer"
                        target="_blank"
                        style="word-break: break-all"
                        class="green-text preset"
                      >
                        {{ file.original }}
                        <span class="help-text" v-if="!showFileText(file)">
                          {{ fileStateText(file) }}
                        </span>
                        <span v-if="index !== loadedLesson.homeTask.files.length - 1"><br/></span>
                      </span>
                    </span>
                  </p>
                </v-card-text>
                <v-card-text v-if="answer('home') && !homeTaskRestricted"
                             class="grey lighten-3 answer-row">
                <span class="answer-name" @click="openAnswerPanel('home')">
                  <span>Мой ответ на д/з</span>
                  <span class="status">{{ answerStatus('home') }}</span>
                </span>
                  <span v-if="mark('home')">Оценка{{ mark('home') }}</span>
                  <v-btn text color="primary" @click="openAnswerPanel('home')">Открыть</v-btn>
                </v-card-text>
                <v-card-actions flex class="justify-end mr-2" v-if="!homeTaskRestricted">
                  <v-btn
                    v-if="!answer('home') && allowAnswer"
                    small
                    color="primary"
                    :rounded="true"
                    @click="openNewAnswerPanel('home')"
                    class="white--text">
                    + ответ на д/з
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          </v-row>
        </v-container>
        <v-card-actions class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog=false">Закрыть</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <task-answer-popup
        v-model="showTaskAnswerPopup"
        :answer="selectedAnswer"
        :lessonColor="lessonColor"
        :lesson="lesson"
        v-on:update="updateAnswerEvent"
        v-on:update-files="updateAnswerFilesEvent"
      >
      </task-answer-popup>
      <new-task-answer-popup
        v-model="showNewTaskAnswerPopup"
        :type="newAnswerType"
        :lessonColor="lessonColor"
        :lesson="lesson"
        v-on:update="addAnswerEvent"
      >
      </new-task-answer-popup>
    </v-dialog>
    <v-dialog v-model="showRestrictAccessModal"
              hide-overlay
              max-width="490"
              persistent
    >
      <v-card>
        <v-container>
          <div v-if="classPayType === 'lessons'">
            К сожалению, у вас нет подходящего действующего абонемента,
            чтобы открыть доступ к материалам. Пожалуйста, приобретите новый абонемент.
          </div>
          <div v-if="classPayType !== 'lessons'">
            К сожалению, ваш счет оплачен не полностью. Пожалуйста, оплатите счет.
          </div>
        </v-container>
        <v-card-actions class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="showRestrictAccessModal=false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import moment from 'moment';
import { escape } from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
import {
  answerStatusMap,
  checkAllowRecord,
  checkCancelRecord,
  getClassColor,
  getClassName,
  checkIfFrozen,
} from '@/lib/classHelpers';

import Lesson from '../../api/Lesson';
import TaskAnswerPopup from './TaskAnswerPopup.vue';
import NewTaskAnswerPopup from './NewTaskAnswerPopup.vue';
import Money from '@/components/Money.vue';

export default {
  name: 'LessonPopup',
  props: ['lesson', 'value'],
  components: { Money, TaskAnswerPopup, NewTaskAnswerPopup },
  data: () => ({
    loading: false,
    showTaskAnswerPopup: false,
    showNewTaskAnswerPopup: false,
    selectedAnswer: {},
    newAnswerType: 'lesson',
    lessonItem: null,
    showRestrictAccessModal: false,
    webinarReveal: false,
  }),
  computed: {
    userSubscriptionId() {
      if (this.record
        && this.record.userSubscription
        && this.record.userSubscription.externalId
        && this.$store.state.UISettings.userSubscriptionExternalIdIncluded) {
        const { externalId } = this.record.userSubscription;
        return externalId.length > 6 ? `${externalId.slice(0, 6)}...` : externalId;
      }
      return this.record.userSubscription ? this.record.userSubscription.id : '';
    },
    loadedLesson() {
      return this.lessonItem || this.lesson;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    lessonDate() {
      return moment(this.lesson.date).format('DD.MM.YYYY');
    },
    lessonColor() {
      return getClassColor(this.lesson.classId);
    },
    className() {
      return getClassName(this.lesson.classId);
    },
    filialName() {
      const filial = this.filials.find(f => f.id === this.lesson.filialId);
      return filial ? filial.name : '';
    },
    filialAddress() {
      const filial = this.filials.find(f => f.id === this.lesson.filialId);
      return filial ? filial.address : '';
    },
    teachers() {
      return this.managers
        .filter(m => this.lesson.teacherIds && this.lesson.teacherIds.includes(m.id))
        .map(m => m.name).join(', ');
    },
    roomName() {
      const room = this.rooms.find(r => r.id === this.lesson.roomId);
      return room ? room.name : '';
    },
    record() {
      return this.lesson.records && this.lesson.records.length > 0 ? this.lesson.records[0] : null;
    },
    showRecordButton() {
      return (this.canCancelRecord && this.record) || (this.canRecord && !this.record);
    },
    canRecord() {
      return checkAllowRecord(this.lesson, this.currentUser);
    },
    canCancelRecord() {
      return checkCancelRecord(this.lesson);
    },
    isRecordFrozen() {
      return checkIfFrozen(this.lesson, this.currentUser);
    },
    classPayType() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.payType : null;
    },
    classFreeRecords() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.freeRecords : null;
    },
    comment() {
      if (!this.lesson.comments || !this.lesson.comments.length) {
        return null;
      }

      const comments = this.lesson.comments.slice(0).sort((a, b) => {
        if (a.createdAt < b.createdAt) {
          return 1;
        }
        if (a.createdAt > b.createdAt) {
          return -1;
        }
        return 0;
      });

      return comments[0].comment;
    },
    hasWebinar() {
      return this.lesson.params && this.lesson.params.webinars
        && (this.lesson.params.webinars.length || this.lesson.params.webinars.code);
    },
    webinar() {
      if (this.lesson.params && this.lesson.params.webinars
        && this.lesson.params.webinars.length) {
        return this.lesson.params.webinars[0];
      }
      return null;
    },
    webinarRestricted() {
      if (this.lesson.params && this.lesson.params.webinars && this.lesson.params.webinars.code) {
        return this.lesson.params.webinars.code;
      }
      return null;
    },
    webinarAccessAt() {
      if (this.lesson.params
        && this.lesson.params.webinars
        && this.lesson.params.webinars.data
        && this.lesson.params.webinars.data.accessAt) {
        return moment(this.lesson.params.webinars.data.accessAt).format('DD.MM в HH:mm');
      }
      return null;
    },
    hasVideo() {
      return this.lesson.params && this.lesson.params.videos
        && (this.lesson.params.videos.length || this.lesson.params.videos.code);
    },
    video() {
      if (this.lesson.params && this.lesson.params.videos && this.lesson.params.videos.length) {
        return this.lesson.params.videos[0];
      }
      return null;
    },
    videoRestricted() {
      if (this.lesson.params && this.lesson.params.videos && this.lesson.params.videos.code) {
        return this.lesson.params.videos.code;
      }
      return null;
    },
    videoAccessAt() {
      if (this.lesson.params
        && this.lesson.params.videos
        && this.lesson.params.videos.data
        && this.lesson.params.videos.data.accessAt) {
        return moment(this.lesson.params.videos.data.accessAt).format('DD.MM в HH:mm');
      }
      return null;
    },

    hasLessonTask() {
      return this.loadedLesson && this.loadedLesson.lessonTask;
    },
    lessonTaskRestricted() {
      if (this.loadedLesson.lessonTask && this.loadedLesson.lessonTask.code) {
        return this.loadedLesson.lessonTask.code;
      }
      return null;
    },
    lessonTaskAccessAt() {
      if (this.loadedLesson.lessonTask
        && this.loadedLesson.lessonTask.data
        && this.loadedLesson.lessonTask.data.accessAt) {
        return moment(this.loadedLesson.lessonTask.data.accessAt).format('DD.MM в HH:mm');
      }
      return null;
    },

    hasHomeTask() {
      return this.loadedLesson && this.loadedLesson.homeTask;
    },
    homeTaskRestricted() {
      if (this.loadedLesson.homeTask && this.loadedLesson.homeTask.code) {
        return this.loadedLesson.homeTask.code;
      }
      return null;
    },
    homeTaskAccessAt() {
      if (this.loadedLesson.homeTask
        && this.loadedLesson.homeTask.data
        && this.loadedLesson.homeTask.data.accessAt) {
        return moment(this.loadedLesson.homeTask.data.accessAt).format('DD.MM в HH:mm');
      }
      return null;
    },

    lessonInfoWidth() {
      if (this.lesson.status === 1) {
        return this.record ? 8 : 12;
      }
      const canRecordCond = !this.record && this.canRecord;
      const canCancelRecordCond = this.record && this.canCancelRecord;
      const markCond = this.mark('lesson') || this.mark('home');
      const isFrozenCond = this.isRecordFrozen && !this.record;
      // return isFrozenCond ? 7 : (canRecordCond || canCancelRecordCond || markCond ? 8 : 12);
      if (isFrozenCond) return 7;
      if (canRecordCond || canCancelRecordCond || markCond) return 8;
      return 12;
    },
    recordButtonWidth() {
      return 12 - this.lessonInfoWidth;
    },
    hasYoutubeVideo() {
      if (!this.video || !this.dialog) {
        return false;
      }
      return this.hasCommonYoutubeVideo || this.hasAlterYoutubeVideo;
    },
    hasVkVideo() {
      if (!this.video || !this.dialog) {
        return false;
      }
      return this.hasVkCommonVideo;
    },
    hasRutubeVideo() {
      if (!this.video || !this.dialog) {
        return false;
      }
      return this.hasRutubeCommonVideo;
    },
    hasVimeoVideo() {
      if (!this.video || !this.dialog) {
        return false;
      }
      return this.hasVimeoCommonVideo;
    },
    hasCommonYoutubeVideo() {
      const youtubeRegexp = /youtube.com\/watch/g;
      return String(this.video.value).match(youtubeRegexp);
    },
    hasVkCommonVideo() {
      const vkRegexp = /vk.com\/(video|clip)/g;
      const { value } = this.video;
      return String(value).match(vkRegexp);
    },
    hasRutubeCommonVideo() {
      const rutubeRegexp = /rutube.ru(\/live)?\/video/g;
      return String(this.video.value).match(rutubeRegexp);
    },
    hasVimeoCommonVideo() {
      const vimeoRegexp = /vimeo.com\//g;
      const { value } = this.video;
      return String(value).match(vimeoRegexp);
    },
    hasAlterYoutubeVideo() {
      const alterRegexp = /youtu.be\/.+/g;
      return String(this.video.value).match(alterRegexp);
    },
    youtubeEmbedLink() {
      if (!this.hasYoutubeVideo) {
        return '';
      }
      let videoLink = '';
      if (this.hasCommonYoutubeVideo) {
        const videoIdRegexp = /v=.+/g;
        videoLink = String(this.video.value).match(videoIdRegexp);
        if (!videoLink || !videoLink.length) {
          return '';
        }
        return `https://www.youtube.com/embed/${videoLink[0].replace('v=', '')}`;
      }

      let extractedLink = String(this.video.value).replace('https://youtu.be/', '');
      extractedLink = String(extractedLink).replace('https://www.youtu.be/', '');
      return `https://www.youtube.com/embed/${extractedLink}`;
    },
    vkEmbedLink() {
      if (!this.hasVkVideo) {
        return '';
      }
      const value = this.video.directLink;
      return value;
    },
    rutubeEmbedLink() {
      if (!this.hasRutubeVideo) {
        return '';
      }
      const videoIdRegexp = /video.+/g;
      const { value } = this.video;
      const videoLink = String(value).match(videoIdRegexp);
      if (!videoLink || !videoLink.length) {
        return '';
      }
      return `https://www.rutube.ru/play/embed/${videoLink[0].replace('video', '')}`;
    },
    vimeoEmbedLink() {
      if (!this.hasVimeoVideo) {
        return '';
      }
      const { value } = this.video;
      if (value) {
        const videoLink = value.split('/');
        return `https://player.vimeo.com/video/${videoLink[videoLink.length - 1]}`;
      }
      return '';
    },
    videoLink() {
      return this.youtubeEmbedLink
        || this.rutubeEmbedLink
        || this.vimeoEmbedLink
        || this.vkEmbedLink;
    },
    allowAnswer() {
      return this.UISettings.answerActions.create;
    },
    allowAnswerIfNoTask() {
      return this.UISettings.answerActions.createAnswerIfNoTask;
    },
    missedLesson() {
      if (!this.record.missedRecord) return null;
      const cl = this.classes.find(({ id }) => id === this.record.missedRecord.classId);
      const c = this.courses.find(({ id }) => id === cl.courseId);
      const f = this.filials.find(({ id }) => id === cl.filialId);
      return {
        classTitle: `${c ? c.name : ''} ${cl ? cl.name : ''}`,
        filialName: f ? f.name : '',
        date: moment(this.record.missedRecord.date).format('DD.MM.YYYY'),
      };
    },
    workOffLesson() {
      const cl = this.classes.find(({ id }) => id === this.record.workOffRecord.classId);
      const c = this.courses.find(({ id }) => id === cl.courseId);
      const f = this.filials.find(({ id }) => id === cl.filialId);
      return {
        classTitle: `${c ? c.name : ''} ${cl ? cl.name : ''}`,
        filialName: f ? f.name : '',
        date: moment(this.record.workOffRecord.date).format('DD.MM.YYYY'),
      };
    },
    ...mapGetters(['classes', 'courses', 'filials', 'rooms', 'managers', 'currentUser', 'UISettings']),
  },
  methods: {
    ...mapMutations(['setCreateJoinDialog']),
    createRecord() {
      const targetClass = this.classes.find(({ id }) => id === this.lesson.classId);
      const { onlinePayment } = targetClass;
      const isPaymentForJoinCombined = onlinePayment.paymentForJoin === 'combined';
      const userIsNotRecord = !this.currentUser.joins
        .find(({ classId }) => classId === this.lesson.classId);

      if (isPaymentForJoinCombined && userIsNotRecord) {
        this.setCreateJoinDialog({
          filialId: targetClass.filialId,
          lessonIds: [this.lesson.id],
          lessons: [this.lesson],
          cl: targetClass,
        });
      } else {
        this.$emit('record');
        this.dialog = false;
      }
    },
    cancelRecord() {
      this.dialog = false;
      this.$emit('cancelRecord');
    },
    updateAnswerEvent(answer) {
      const index = this.lesson.answers.findIndex(a => a.id === answer.id);
      if (!answer.remove) {
        this.selectedAnswer = answer;
        if (index !== -1) {
          this.lesson.answers[index] = answer;
        }
      } else {
        this.selectedAnswer = null;
        this.lesson.answers.splice(index, 1);
      }
    },
    updateAnswerFilesEvent(answer) {
      const index = this.lesson.answers.findIndex(a => a.id === answer.id);
      this.selectedAnswer.files = answer.files;
      if (index !== -1) {
        this.lesson.answers[index].files = answer.files;
      }
    },
    addAnswerEvent(answer) {
      if (!this.answer(answer.type)) {
        this.lesson.answers.push(answer);
      }
    },
    mark(type) {
      const { marks } = this.lesson;
      if (!marks || !marks.length) {
        return '';
      }
      const mark = marks.find(m => m.type === type);
      return mark ? ` - ${mark.value}` : '';
    },
    answer(type) {
      const { answers } = this.lesson;
      if (!answers || !answers.length) {
        return null;
      }
      return answers.find(a => a.type === type);
    },
    answerStatus(type) {
      const answer = this.answer(type);
      if (answer) {
        return answerStatusMap[answer.status].label;
      }
      return '';
    },
    file(type) {
      const taskKey = type === 'home' ? 'homeTask' : 'lessonTask';
      if (this.lesson[taskKey] && this.lesson[taskKey].files.length) {
        return this.lesson[taskKey].files[0];
      }

      return null;
    },

    getTextWithLinks(text) {
      if (!text) {
        return '';
      }
      const urlRegexpWithHttp = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*))/g;
      return escape(text).replace(urlRegexpWithHttp, '<a href=\'$1\' target=\'_blank\'>$1</a>');
    },

    getTaskText(text) {
      return text;
    },

    async openAnswerPanel(type) {
      const answer = this.answer(type);
      try {
        const loadedAnswerResponse = await Lesson.getAnswer(this.lesson.id, answer.id, {
          scopeUserId: this.currentUser.id,
        });
        const { data } = loadedAnswerResponse;
        const index = this.lesson.answers.findIndex(a => a.id === answer.id);
        if (index !== -1) {
          this.lesson.answers[index] = data;
        }
        this.selectedAnswer = data;
        this.showTaskAnswerPopup = true;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          const index = this.lesson.answers.findIndex(a => a.id === answer.id);
          this.selectedAnswer = null;
          this.lesson.answers.splice(index, 1);
        }
      }
    },

    async openNewAnswerPanel(type) {
      this.newAnswerType = type;
      this.showNewTaskAnswerPopup = true;
    },

    async downloadFile(file) {
      try {
        this.loading = true;
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'url',
              url: file.downloadUrl,
            }),
          );
        } else {
          window.open(file.downloadUrl, '_blank', 'noreferrer');
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    showFileText(file) {
      return file.uploadState && file.uploadState !== 'done';
    },

    fileStateText(file) {
      return file.uploadState === 'process' ? 'Обрабатывается' : 'Ошибка загрузки';
    },
    async loadLesson() {
      const filter = {
        scopeUserId: this.currentUser.id,
        includeRecords: true,
        includeTasks: true,
        includeMarks: true,
        includeParams: true,
        includeComments: true,
        includeTaskAnswers: true,
        includeUserSubscriptions: true,
      };
      const result = await Lesson.getOne(this.lesson.id, filter);
      this.lessonItem = result.data;
    },

    openLink() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'url',
            url: this.video.value,
          }),
        );
      } else {
        window.open(this.video.value, '_blank', 'noreferrer');
      }
    },
  },

  mounted() {
    this.loadLesson();
  },
};
</script>

<style scoped lang="less">
.answer-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;

  .answer-name {
    cursor: pointer;
  }

  .status {
    margin-left: 5px;
    color: rgb(137, 137, 137);
    font-size: 12px;
  }
}

.video-box {
  padding: 0 5px 16px;
  div {
    padding-left: 12px;
  }
  iframe {
    background-color: #eeeeee;
    // background-color: #000000;
  }
}
</style>
